import { render } from "./DefaultExpandedAndDefaultChecked.vue?vue&type=template&id=53826b9c"
import script from "./DefaultExpandedAndDefaultChecked.vue?vue&type=script&lang=js"
export * from "./DefaultExpandedAndDefaultChecked.vue?vue&type=script&lang=js"
script.render = render

export default script